import { z } from 'zod';
import { nullishAsUndefined } from './utils';

export const instanceDetailSchema = z.object({
  instanceId: z.string({ required_error: 'Instance ID' }).min(1, 'Instance ID'),
  instanceName: nullishAsUndefined(z.string().optional()),
  fromTime: z.string().optional(),
  toTime: z.string().optional(),
});

export const shardedClusterDetailSchema = z.object({
  instanceId: z.string({ required_error: 'Instance ID' }).min(1, 'Instance ID'),
  instanceName: nullishAsUndefined(z.string().optional()),
  subType: nullishAsUndefined(z.string().optional()),
  fromTime: z.string().optional(),
  toTime: z.string().optional(),
});

export const clusterDetailSchema = z.object({
  instanceId: z.string({ required_error: 'Instance ID' }).min(1, 'Instance ID'),
  instanceName: nullishAsUndefined(z.string().optional()),
  databaseName: nullishAsUndefined(z.string().optional()),
  fromTime: z.string().optional(),
  toTime: z.string().optional(),
});

export type InstanceDetailSchema = z.infer<typeof instanceDetailSchema>;
export type ShardedClusterDetailSchema = z.infer<typeof shardedClusterDetailSchema>;
export type ClusterDetailSchema = z.infer<typeof clusterDetailSchema>;

export type InstanceDetailAddition = Omit<InstanceDetailSchema, 'instanceName'>;
export type ShardedClusterDetailAddition = Omit<
  ShardedClusterDetailSchema,
  keyof InstanceDetailSchema
>;
export type ClusterDetailAddition = Omit<ClusterDetailSchema, 'instanceName'>;
